import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { ThemeService } from 'src/app/services/client/theme/theme.service';

@Component({
  selector: 'app-terms-conditions-modal',
  templateUrl: './terms-conditions-modal.component.html',
  styleUrls: ['./terms-conditions-modal.component.scss']
})
export class TermsConditionsModalComponent {
  @Input() useAccountContent = false;
  readonly bflSectionNumbers = Array.from({ length: 23 }, (_, i) => i + 1);
  readonly bflSchedules = ['a', 'b', 'c', 'd'];

  public currentHeaderData: any = {
    modalSlotEnd: true,
    title: 'Terms and Conditions',
    marl20: true,
    mart4: true,
  };

  constructor(private modalController: ModalController, private analyticsService: AnalyticsService, private theme: ThemeService) {}
  partnerPid = this.theme.getAppPid;
  closeModal() {
    this.analyticsService.trackUnified('terms_closed', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'Terms and Conditions Closed',
      button: 'terms-and-conditions-button',
    });
    this.modalController.dismiss();
  }
}
